import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Cancel } from '@material-ui/icons';
import { NativeSelect, FormControl } from '@material-ui/core'
import { T } from 'Actions/translate';
import util from 'Utils/commonUtil';

class MobileInput extends Component {

    state = {
        emptyValidation: true,
        focus: false,
        selectValue: '0',
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.selectValue){
            this.setState({
                selectValue: nextProps.selectValue
            })
        }

        if(this.input) {
            if(nextProps.value !== this.input.value && util.isString(nextProps.value)) {
                this.input.value = nextProps.value;
            }
        }

        if(util.isString(nextProps.value)){
            let phoneValue = nextProps.value.split("-");

            if(this.areaCode){
                this.areaCode.value = phoneValue[0] || '';
            }

            if(this.phoneNum){
                this.phoneNum.value = phoneValue[1] || '';
            }

            if(this.extensionNum){
                this.extensionNum.value = phoneValue[2] || '';
            }
        }
    }

    clearInput = () => {
        if(this.input){
            this.input.value = '';
        }

        /* if(this.areaCode){
            this.areaCode.value = '';
        }

        if(this.phoneNum){
            this.phoneNum.value = '';
        }

        if(this.extensionNum){
            this.extensionNum.value = '';
        } */

        this.props.inputValid(this.props.title,'')
    }

    foucusInput = () => {
        this.setState({
            focus: true
        })
    }

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false
            });

            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 50);
    }

    inputValid = title => event => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            emptyValidation: empty
        })

        this.input.value = event.target.value.replace(/\D/g, '').substring(0, 11);
        let valueLen = event.target.value.length;

        if (valueLen > 3 && valueLen < 8) {
            this.input.value = event.target.value.substr(0, 3) + ' ' +
                               event.target.value.substr(3)
        } else if (valueLen >= 8) {
            this.input.value = event.target.value.substr(0, 3) + ' ' +
                               event.target.value.substr(3, 4) + ' ' +
                               event.target.value.substr(7)
        }

        this.props.inputValid(title, this.input.value)
    }

    handleChangeSelect = (event) =>{
        this.setState({
            selectValue: event.target.value
        })

        if(this.input){
            this.input.value = '';
        }

        if(this.areaCode){
            this.areaCode.value = '';
        }

        if(this.phoneNum){
            this.phoneNum.value = '';
        }

        if(this.extensionNum){
            this.extensionNum.value = '';
        }

        if(util.isFunction(this.props.inputValid)){
            this.props.inputValid(this.props.title,'')
        }

        if(util.isFunction(this.props.setSelect)){
            this.props.setSelect(event.target.value)
        }
    }

    inputPhone = name => event =>{
        let empty = true;
        if (!this.phoneNum.value && this.props.required) {
            empty = false;
        }
        this.setState({
            emptyValidation: empty
        })

        switch(name){
            case 'areaCode':
                this.areaCode.value = event.target.value.replace(/\D/g, '').substring(0, 4);
                break;
            case 'phoneNum':
                this.phoneNum.value = event.target.value.replace(/\D/g, '').substring(0, 8);
                break;
            case 'extensionNum':
                this.extensionNum.value = event.target.value.replace(/\D/g, '');
                break;
            default :
                break;
        }

        if(this.areaCode && this.phoneNum && this.extensionNum){
            let areaCode = this.areaCode.value || '';
            let phoneNum = this.phoneNum.value || '';
            let extensionNum = this.extensionNum.value || '';
            let value = areaCode + '-' + phoneNum + '-' + extensionNum;

            this.props.inputValid(this.props.title, value);
        }
    }

    render() {
        const { status, title, placeholder } = this.props;
        const { emptyValidation, focus, selectValue } = this.state;
        /* const clearInput = (this.areaCode && this.areaCode.value) || (this.phoneNum && this.phoneNum.value) || (this.extensionNum && this.extensionNum.value);*/

        return (
            <div className={emptyValidation ? 'mobile-input' : 'mobile-input empty'}>

                {status === '0'?
                <label className='input-title'>{T(title)}</label>
                : null }

                {status === '1'?
                <FormControl className='select-mobile'>
		          	<NativeSelect
                        className='select-content'
		            	value={selectValue}
		            	onChange={this.handleChangeSelect}>
		                <option key='0' value='0'>{T('mobile_label')}</option>
		                <option key='1' value='1'>{T('phone_label')}</option>
		          	</NativeSelect>
		        </FormControl>
                : null }

                {selectValue === '0'?
                <input className='input-content'
                        onChange={this.inputValid(title)}
                        placeholder={emptyValidation ? T(placeholder) : T('input_required')}
                        type='tel'
                        ref={(input) => this.input = input}
                        onBlur={this.blurAction}
                        onFocus={this.foucusInput}/>
                : null }
                { selectValue === '0' && this.input && this.input.value && focus ?
                    <Cancel className='cancel-button' onClick={this.clearInput}/>
                : null}

                {selectValue === '1'?
                <div className='phone-content'>
                    <input className='input-area-code'
                        onChange={this.inputPhone('areaCode')}
                        type='tel'
                        ref={(areaCode) => this.areaCode = areaCode}
                    />

                    <span className='span-interval'> - </span>

                    <input className='input-phone-num'
                        onChange={this.inputPhone('phoneNum')}
                        placeholder={emptyValidation ? '' : T('input_required')}
                        type='tel'
                        ref={(phoneNum) => this.phoneNum = phoneNum}
                    />

                    <span className='span-interval'> - </span>

                    <input className='input-extension-num'
                        onChange={this.inputPhone('extensionNum')}
                        type='tel'
                        ref={(extensionNum) => this.extensionNum = extensionNum}
                    />
                </div>
                : null }
                {/*  selectValue === '1' && clearInput && focus ?
                    <Cancel className='cancel-button' onClick={this.clearInput}/>
                : null */}
            </div>
        )
    }
}

MobileInput.propTypes = {
    title: PropTypes.string.isRequired,
};

export default MobileInput
